<template>
  <div>
    <Header />
    <Article />
  </div>
</template>
<script>
import Header from '@/components/common/layout/Header.vue'
import Article from '@/components/common/layout/Article.vue'

export default {
  name: 'DefaultLayoutNoStatus',
  components: {
    Header,
    Article,
  },
}
</script>
